import Axios from "axios";

class FuncionarioPontoDataService {
  getFuncionarios() {
    return Axios.get("funcionarios");
  }

  getAll(params) {
    return Axios.get("funcionariosPonto/period", { params });
  }

  getPage(params) {
    return Axios.get("funcionariosPonto/page/period", { params });
  }

  getResumoPeriodo(params) {
    return Axios.get("funcionariosPonto/period/resume", { params });
  }

  getAusenciaDashboard(params) {
    return Axios.get("funcionarioPontoAusenciaDashboard", { params });
  }

  getEquipamentosDashboard(params) {
    return Axios.get("funcionarioPontoEquipamentosDashboard", { params });
  }

  getOcorrenciasDashboard(params) {
    return Axios.get("funcionarioPontoOcorrenciasDashboard", { params });
  }

  getHorasDashboard(params) {
    return Axios.get("funcionarioPontoHorasDashboard", { params });
  }

  validarDiaCalculo(diaId) {
    return Axios.put(
      `funcionarioPontoCalculos/folhaPonto/assinaturaResponsavel/dia/${diaId}`
    );
  }

  getRelatorioCercaPerimetroPdf(params) {
    return Axios.post(
      "funcionariosPonto/dashboard/cerca-perimetro/print",
      params,
      { responseType: "blob" }
    );
  }

  create(params) {
    return Axios.post("funcionariosPonto", params);
  }

  update(params) {
    return Axios.put("funcionariosPonto/" + params.id, params);
  }

  find(id) {
    return Axios.get(`funcionariosPonto/${id}`);
  }

  delete(id, justificativaInabilitacao) {
    return Axios.delete(`funcionariosPonto/${id}`, {
      params: { justificativaInabilitacao },
    });
  }

  invert(id) {
    return Axios.put(`funcionariosPonto/invert/${id}`);
  }

  share(id) {
    return Axios.put(`funcionariosPonto/share/${id}`);
  }

  getComprovanteLink(params) {
    return Axios.get("funcionariosPonto/comprovante/link/param", { params });
  }

  insertSimplifiedList(params) {
    return Axios.post("funcionariosPonto/import/list", params);
  }

  getListaFuncionarios(params) {
    return Axios.post("funcionariosPonto/filter", params);
  }

  getTransferenciaDestinos(funcionarioOrigemId, params) {
    return Axios.get(
      `funcionariosPonto/transferencia/destinos/${funcionarioOrigemId}`,
      { params }
    );
  }

  transferirDetalhes(params) {
    return Axios.put("funcionariosPonto/transferencia", params);
  }
}

export default new FuncionarioPontoDataService();
